export const defaultOptionState = {
	OptionsData: []
};

export default {
	...defaultOptionState
};
